import {createRouter, createWebHistory} from 'vue-router'
import store from "../store";

import EmptyLayout from '../layouts/EmptyLayout';

// Roles
import superAdministrator from './superAdministrator'
import mainHr from './mainHr'
import hr from './hr'
import directionLeader from './directionLeader'
import securituService from './securituService'
import approvingPerson from './approvingPerson.js'


const routes = [
    {
        path: '/',
        redirect: () => {
            return '/authorization'
        },
    },
    {
        path: '/authorization',
        name: 'Authorization',
        meta: {layout: EmptyLayout},
        component: () => import('../views/authorization')
    },
    {
        path: '/agreement',
        name: 'Agreement',
        meta: {layout: EmptyLayout},
        component: () => import('../views/agreement')
    },
]

const router = createRouter({
    history: createWebHistory(),
    routes: [...routes, ...superAdministrator, ...mainHr, ...hr, ...directionLeader, ...securituService, ...approvingPerson],
})

router.beforeEach(async (to, from, next) => {

    // Если есть токен, обновляем данные аутентификации
    if (localStorage.token) {
        await store.dispatch("auth/auth", {
            token: localStorage.token,
            role: localStorage.role
        });
    }

    // Если пользователь пытается попасть на страницу авторизации, но уже авторизован,
    // перенаправляем его на страницу по умолчанию для его роли
    if (to.fullPath === '/authorization') {
        if (store.getters['auth/role'] === 'SUPER_ADMIN') next('/companies?tabs=all')
        else if (store.getters['auth/role'] === 'ADMIN') next('/vacancies?tabs=open&page=1')
        else if (store.getters['auth/role'] === 'HR') next('/vacancies')
        else if (store.getters['auth/role'] === 'APPROVING_PERSON') next('/responses')
        else if (store.getters['auth/role'] === 'DIRECTION_LEADER') next('/tasks')
        else if (store.getters['auth/role'] === 'SECURITY_SERVICE') next('/sb-tasks')
        else next() // если роль неизвестна, разрешаем переход
        return
    }

    // Если пользователь не авторизован
    if (!store.getters['auth/token']) {
        if (to.fullPath === '/agreement') {
            next() // разрешаем переход на страницу соглашения
        } else {
            next('/authorization') // все остальные пути ведут на авторизацию
        }
        return
    }

    // Проверяем, есть ли у маршрута мета-поле role
    if (to.meta.role) {
        // Если роль пользователя совпадает с требуемой ролью маршрута, разрешаем переход
        if(to.meta.role === "HR" && store.getters['auth/role'] === "ADMIN")  return next()
        if(to.meta.role === "HR" && store.getters['auth/role'] === "APPROVING_PERSON") {
            if (to.path?.includes('responses') || to.path?.includes('application')) {
                return next()
            } else {
                next('/responses')
            }
        }
        if (to.meta.role === store.getters['auth/role']) {
            next()
        } else {
            // Если роль не совпадает, перенаправляем на страницу по умолчанию для роли
            if (store.getters['auth/role'] === 'SUPER_ADMIN') next('/companies?tabs=all')
            else if (store.getters['auth/role'] === 'ADMIN') next('/vacancies?tabs=open&page=1')
            else if (store.getters['auth/role'] === 'HR') next('/vacancies')
            else if (store.getters['auth/role'] === 'APPROVING_PERSON') next('/responses')
            else if (store.getters['auth/role'] === 'DIRECTION_LEADER') next('/tasks')
            else if (store.getters['auth/role'] === 'SECURITY_SERVICE') next('/sb-tasks')
            else next('/authorization') // если роль неизвестна, отправляем на авторизацию
        }
    } else {
        // Если у маршрута нет meta.role, разрешаем переход (например, для общих страниц)
        next()
    }
})

export default router

